import styled from 'styled-components';
import MaskedInput from 'react-text-mask';

export const PhoneNumberForm = styled(MaskedInput)`
  border-top: none;
  border-left: none;
  border-right: none;
`;
